import type { ReactElement } from 'react';
import { ErrorCode } from '@gr/core/errors';
import { useT } from '../../../../app/di';
import { FormAlert, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

/** POST-UC-1: новый пост — сначала только название; отправка — кнопкой с form={id}. */
export function CreatePostForm({ id, onSubmit }: { id: string; onSubmit(title: string): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<{ title: string }>({ defaultValues: { title: '' }, fields: ['title'], onSubmit: ({ title }) => onSubmit(title) });
  return (
    <form id={id} className="u-stack" onSubmit={submit} noValidate>
      <FormAlert form={form} />
      <FormTextField
        control={form.control}
        name="title"
        label={t('posts.list.newTitle')}
        hint={t('posts.list.newHint')}
        autoFocus
        rules={{ required: ErrorCode.FieldRequired }}
        disabled={form.formState.isSubmitting}
      />
    </form>
  );
}
